import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';

const Cover = ({ context }) => {
	
	const ctxGlobal 		= () => context.global;
	const global 			= ctxGlobal();
	
	const ctxSiteLoaded 	= () => context.siteLoaded;
	const siteLoaded 		= ctxSiteLoaded();
	
	const ctxShowVideo 		= () => context.showVideo;
	const showVideo 		= ctxShowVideo();
	
	function handleIntroEnd(evt) {
	  	evt.preventDefault();
	  	context.handleIntroEnd();
  	}
  	
	if (global.json !== null) {
		
		let coverClass = 'c-cover';
		if (siteLoaded) {
			coverClass = coverClass + ' state-site-loaded';
		}
		
		if (showVideo === true) {
		
			return (
				<div className={coverClass}>
					<div className="c-cover__video">
						<video src={global.json.intro_animation} onEnded={handleIntroEnd} playsInline muted autoPlay></video>
					</div>
				</div>
			)
		
		} else {
			return (
				<div className={coverClass}></div>
			)
			
		}
	
	} else {
		
		return (
			<div className="c-cover"></div>
		)
		
	}
}
export default WithConsumer(Cover);